import React from 'react';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';

import './ErrorBoundary.scss';
import Button from '../../common/Buttons/Button';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  refreshPage = () => {
    window.location.reload();
  };

  componentDidCatch() {
    this.setState({ hasError: true, errorIndex: _.random(1, 3, false) });
  }

  render() {
    const { children } = this.props;
    const { t } = this.props;
    const { hasError, errorIndex } = this.state;
    if (hasError) {
      return (
        <div className="error-boundary">
          <span className="image col-left" />
          <span className="col-right">
            <div className="title">{t('error.title')}</div>
            <div className="body">
              <div className="line1">{t(`error.desc${errorIndex}.line1`)}</div>
              <div className="line2">{t(`error.desc${errorIndex}.line2`)}</div>
            </div>
            <Button className="btn-reload" onClick={this.refreshPage}>
              Refresh
            </Button>
          </span>
        </div>
      );
    }

    return children;
  }
}

export default withTranslation()(ErrorBoundary);
